var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconText = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 15"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#787878"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.708 14.473V3.169H16V.606H4.267v2.563h4.292v11.304z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.805 14.473V7.136H6V5.473H0v1.663h2.195v7.337z"
}))));

export default SvgIconText;